module.exports = __webpack_public_path__ + "static/media/preview.39614e3a.png";